<div *ngIf="product" class="container">
    <div class="collapseButton" (click)="collapseProductOverview()">
        <div class="collapseButtonIcon"></div>
    </div>
    <div class="leftSide">
        <label for="productName"> Name </label>
        <h1 id="productName">{{ product.name }}</h1>

        <label for="description"> Beschreibung</label>
        <p id="description" [innerHTML]="product.description"></p>

        <button
            mat-raised-button
            class="btn_green"
            (click)="navigateToProduct()"
        >
            Details
        </button>
    </div>
    <div class="rightSide">
        <label for="ptgs">Produkttyp</label>
        <div id="ptgs">
            <p *ngFor="let ptg of mockPTGs" class="ptgItem">{{ ptg }}</p>
        </div>
        <label for="features">Allg. Merkmale</label>
        <div id="features">
            <div *ngFor="let feature of mockFeatures" class="featureItem">
                <span
                    ><b>{{ feature.label }}: </b></span
                >
                <span>{{ feature.name }}</span>
            </div>
        </div>
        <label for="certificates">Zertifikate</label>
        <div id="certificates">
            <p
                *ngFor="let certificate of mockCertificates"
                class="certificateItem"
            >
                {{ certificate }}
            </p>
        </div>
        <label for="inputFormats">Input Formate</label>
        <div id="inputFormats">
            <p *ngFor="let format of mockInputFormats" class="inputFormatItem">
                {{ format }}
            </p>
        </div>
        <label for="outputFormats">Output Formate</label>
        <div id="outputFormats">
            <p
                *ngFor="let format of mockOutputFormats"
                class="outputFormatItem"
            >
                {{ format }}
            </p>
        </div>
    </div>
    <mat-spinner *ngIf="!product"></mat-spinner>
</div>
